
import {Component, Vue} from 'vue-property-decorator';
import {IRole} from '@/interfaces/role';
import {
  dispatchCreateRole,
  dispatchGetDefaultRoleSetting, dispatchGetRole,
  dispatchGetRolesAdmin,
  dispatchUpdateRole,
} from '@/store/admin/actions';
import {readAdminRole, readAdminRoles, readDefaultRoleSettings} from '@/store/admin/getters';
import {rules} from '@/utils';
import DefaultHelp from '@/components/tooltips/DefaultHelp.vue';
import RoleSettings from '@/components/extras/RoleSettings.vue';
import {dispatchGetUserProfile} from '@/store/main/actions';

@Component({
  components: {RoleSettings, DefaultHelp},
})
export default class CRUDRole extends Vue {
  private role: IRole = {} as IRole;
  private rules: any = rules;

  private valid: boolean = false;
  private title: string = `${this.$t('crud.create')} ${this.$t('role')}`;
  private roleId: number = -1;


  public async mounted() {
    this.roleId = this.$router.currentRoute.params.id as unknown as number;
    await dispatchGetDefaultRoleSetting(this.$store);

    // if (readAdminRoles(this.$store).length < 1) {
    //   await dispatchGetRolesAdmin(this.$store);
    // }

    if (this.roleId > 0) {
      await dispatchGetRole(this.$store, this.roleId);
      this.title = `${this.$t('crud.update')} ${this.$t('role')}`;
      this.role = await readAdminRole(this.$store)(+this.roleId) as IRole;
      if (!this.role.settings) {
        this.role.settings = this.defaultSettings;
      }
    } else {
      this.role = {settings: this.defaultSettings} as IRole;
      this.roleId = 0;
    }

  }

  public beforeRouteLeave(to, from, next) {
    this.role = {} as IRole;
    this.title = `${this.$t('crud.create')} ${this.$t('role')}`;
    this.roleId = 0;
    dispatchGetDefaultRoleSetting(this.$store);
    next();
  }

  public changeSettings(val) {
    this.role.settings = val;
  }

  private get defaultSettings() {
    return readDefaultRoleSettings(this.$store);
  }

  private cancel() {
    this.$router.back();
  }

  private reset() {
    this.role = {} as IRole;
  }

  private async submit() {
    const form: any = this.$refs.form_crud_role;
    if (await form.validate()) {
      if (this.roleId > 0) {
        if (await dispatchUpdateRole(this.$store, this.role)) {
          await dispatchGetUserProfile(this.$store);
          await this.$router.push({name: 'main-admin-roles-list'});
        }
      } else {
        if (await dispatchCreateRole(this.$store, this.role)) {
          await this.$router.push({name: 'main-admin-roles-list'});
        }
      }
    }
  }


}
